import React from "react";
import "./index.scss";

const InfoModalContent = () => {
  return (
    <div className="info-wrapper">
      <div className="acpt-docs pb-2">
        List of Acceptable Documents for I9 Verification
      </div>
      <div className="docs-details pb-3">
        All documents with an expiration date must be unexpired. Documents
        extended by the issuing authority are considered unexpired. Employees
        may present one selection from List A or a combination of one selection
        from List B and one from List C.
      </div>
      <div className="doc-type pb-2">
        List A: Documents that Establish Both Identity and Employment
        Authorization
      </div>
      <div className="docs-details">
        <ul>
          <li>U.S. Passport or U.S. Passport Card</li>
          <li>
            Permanent Resident Card or Alien Registration Receipt Card (Form
            I-551)
          </li>
          <li>Foreign passport with a temporary I-551 stamp or notation</li>
          <li>
            Employment Authorization Document with a photograph (Form I-766)
          </li>
          <li>
            Foreign passport with Form I-94/I-94A indicating status and work
            authorization
          </li>
          <li>
            Passport from FSM or RMI with Form I-94/I-94A indicating
            nonimmigrant admission
          </li>
        </ul>
      </div>
      <div className="doc-type pb-2">
        List B: Documents that Establish Identity
      </div>
      <div className="docs-details">
        <ul>
          <li>
            Driver's license or ID card issued by a U.S. state or outlying
            possession
          </li>
          <li>
            ID card issued by federal, state, or local government agencies or
            entities
          </li>
          <li>School ID card with a photograph</li>
          <li>Voter's registration card</li>
          <li>U.S. Military card or draft record</li>
          <li>Military dependent's ID card</li>
          <li>U.S. Coast Guard Merchant Mariner Card</li>
          <li>Native American tribal document</li>
          <li>Driver's license issued by a Canadian government authority</li>
        </ul>
      </div>
      <div className="doc-type pb-2">
        For persons under age 18 who are unable to present one of the above
        documents
      </div>
      <div className="docs-details">
        <ul>
          <li>School record or report card</li>
          <li>Clinic, doctor, or hospital record</li>
          <li>Day-care or nursery school record</li>
        </ul>
      </div>
      <div className="doc-type pb-2">
        List C: Documents that Establish Employment Authorization
      </div>
      <div className="docs-details pb-2">
        <ul>
          <li>Social Security Account Number card without restrictions</li>
          <li>
            Certification of report of birth issued by the Department of State
            (Forms DS-1350, FS-545, FS-240)
          </li>
          <li>
            Original or certified copy of birth certificate issued by a U.S.
            state, county, municipal authority, or territory bearing an official
            seal
          </li>
          <li>Native American tribal document</li>
          <li>U.S. Citizen ID Card (Form I-197)</li>
          <li>
            Identification Card for Use of Resident Citizen in the United States
            (Form I-179)
          </li>
          <li>Employment authorization document issued by DHS</li>
        </ul>
      </div>
    </div>
  );
};

export default InfoModalContent;
